import {BrowserRouter} from "react-router-dom";
import {Layout} from "components/layout";
import RoutePage from "./routes";
import {Provider} from "react-redux";
import store from "./reducers";
import { useEffect } from "react";

function App() {
    useEffect(() => {
        if (window.top !== window.self) {
            window.top.location = window.self.location;
        }
    }, []);

    return (
        <Provider store={store}>
            <BrowserRouter>
                <Layout>
                    <RoutePage/>
                </Layout>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
